import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=80c963a4&scoped=true&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=80c963a4&prod&lang=less&scoped=true&"
import style1 from "./Analysis.vue?vue&type=style&index=1&id=80c963a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c963a4",
  null
  
)

export default component.exports